export default "__VITE_ASSET__fYM5a527__"